import React from "react";
import ReactModal from "react-modal";
import { Formik } from "formik";
import { Col, Form } from "react-bootstrap";
import "./index.scss";
import { getMerchantInfo, UpdateApproval, bankList } from "../../../api";
import Loader from "../../loader/loader";
import SelectDropDown from "../../shared/drop-down/drop-down";

import * as yup from "yup";
const schema = yup.object({
    who_is_billed: yup.string().trim().required("* This filed is required"),
    who_is_deploying: yup.string().trim().required("* This filed is required"),
    contact_permission: yup
        .string()
        .trim()
        .required("* This filed is required"),
    reserve_required: yup.string().trim().required("* This filed is required"),
});
class ProgressApproval extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: props.selectedTemplate ? true : false,
            is_submitted: false,
            show_spinner: false,
            errorMessage: "",
            formData: {
                who_is_billed: "",
                who_is_deploying: "",
                processor: "",
                contact_permission: "",
                reserve_required: "",
                notes: "",
            },
            errors: [],
            processorType: ["EMS", "EMS OR", "Priority CBD"],
            appEquipment: {},
            banks: {},
        };
    }

    updateChange(evt) {
        const targetName = evt.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;

        formData[targetName] = evt.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    componentDidMount() {
        this.setState({ show_spinner: true });
        this.getAppInfo();
    }

    handleApproval(evt) {
        this.setState({ show_spinner: true });
        const fromData = this.state.formData;
        const postData = {
            id: this.props.appData.id,
            who_is_billed: fromData.who_is_billed,
            who_is_deploying: fromData.who_is_deploying,
            processor:
                fromData.who_is_deploying == "Processor"
                    ? fromData.processor
                    : null,
            contact_permission: fromData.contact_permission,
            reserve_required: fromData.reserve_required,
            notes: fromData.notes,
        };
        UpdateApproval(postData).then((res) => {
            if (res.status) {
                this.setState({ errorMessage: res.message });
                setTimeout(() => {
                    this.props.handleProgression();
                }, 1000);
            } else {
                this.setState({
                    show_spinner: false,
                    errorMessage: res.message,
                });
            }
        });
    }

    getAppInfo() {
        let data = {};
        data.id = this.props.appData.id;
        getMerchantInfo(data)
            .then((response) => {
                if (response.status) {
                    const fromData = this.state.formData;
                    fromData.equipment_option =
                        response.powerappequipment.equipment_option;
                    fromData.equipment_type =
                        response.powerappequipment.equipment_type;
                    this.setState({ formData: fromData }, () => {
                        this.getBankList();
                    });
                } else {
                    this.getBankList();
                }
            })
            .catch((error) => {
                this.getBankList();
            });
    }

    getBankList() {
        let data = {};
        data.id = this.props.appData.id;
        bankList(data)
            .then((response) => {
                if (response.status) {
                    this.setState({ banks: response.bank_list }, () => {
                        this.setState({ show_spinner: false });
                    });
                } else {
                    this.setState({ show_spinner: false });
                }
            })
            .catch((error) => {});
    }

    handleProcessorChange(value) {
        let formData = this.state.formData;
        formData["processor"] = value;
        this.setState({ formData: formData });
    }

    handleNotesChange(e) {
        const fromData = this.state.formData;
        fromData.notes = e.target.value;
        this.setState({ formData: fromData });
    }

    render() {
        const {
            isEdit,
            show_spinner,
            errorMessage,
            formData,
            errors,
            is_submitted,
        } = this.state;
        return (
            <ReactModal
                isOpen={this.props.showProgressApprovalModel}
                className="update-approval"
            >
                <div className="modal-header">
                    <h4 className="text-left">Approval</h4>
                </div>
                <div
                    onClick={() => this.props.handleCloseModel()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-body">
                    <Formik
                        enableReinitialize
                        validationSchema={schema}
                        onSubmit={(e) => this.handleApproval(e)}
                        initialValues={formData}
                        initialErrors={errors}
                        validateOnBlur={false}
                        validateOnChange={is_submitted}
                        validate={(values) => {
                            this.setState({ is_submitted: true });
                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            values,
                            touched,
                            errors,
                        }) => (
                            <Form
                                id="updateApproval"
                                onSubmit={handleSubmit}
                                onChange={(e) => this.updateChange(e)}
                                autoComplete="off"
                            >
                                <Form.Row>
                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="pri-heading1 mg-bottom-15">
                                            Who is Deploying
                                        </div>
                                        <div className="d-flex tire-new">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="who_is_deploying"
                                                    value="Merchant"
                                                    checked={
                                                        values.who_is_deploying ===
                                                        "Merchant"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Merchant
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="who_is_deploying"
                                                    value="Agent"
                                                    checked={
                                                        values.who_is_deploying ===
                                                        "Agent"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Agent
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="who_is_deploying"
                                                    value="PaymentCloud"
                                                    checked={
                                                        values.who_is_deploying ===
                                                        "PaymentCloud"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    PaymentCloud
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="who_is_deploying"
                                                    value="Processor"
                                                    checked={
                                                        values.who_is_deploying ===
                                                        "Processor"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Processor
                                                </span>
                                            </label>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.who_is_deploying}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    {values.who_is_deploying == "Processor" && (
                                        <Form.Group
                                            as={Col}
                                            xs={12}
                                            className="px-3"
                                        >
                                            <div className="pri-heading1 mg-bottom-15">
                                                Which Processor
                                            </div>
                                            <SelectDropDown
                                                isSearchable={true}
                                                options={this.state.banks}
                                                name="processor"
                                                placeholder="Select One"
                                                value=""
                                                handleChange={(selected) => {
                                                    this.handleProcessorChange(
                                                        selected.value,
                                                    );
                                                }}
                                            />
                                            <Form.Control.Feedback
                                                type="invalid"
                                                className="text-capitalize"
                                            >
                                                {" "}
                                                {errors.processor}{" "}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    )}

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="pri-heading1 mg-bottom-15">
                                            Who is Billed
                                        </div>
                                        <div className="d-flex tire-new">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="who_is_billed"
                                                    value="Merchant"
                                                    checked={
                                                        values.who_is_billed ===
                                                        "Merchant"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Merchant
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="who_is_billed"
                                                    value="Agent"
                                                    checked={
                                                        values.who_is_billed ===
                                                        "Agent"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Agent
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="who_is_billed"
                                                    value="PaymentCloud"
                                                    checked={
                                                        values.who_is_billed ===
                                                        "PaymentCloud"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    PaymentCloud
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="who_is_billed"
                                                    value="Processor"
                                                    checked={
                                                        values.who_is_billed ===
                                                        "Processor"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Processor
                                                </span>
                                            </label>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.who_is_billed}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="pri-heading1 mg-bottom-15">
                                            Contact Permission
                                        </div>
                                        <div className="d-flex tire-new">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="contact_permission"
                                                    value="Merchant"
                                                    checked={
                                                        values.contact_permission ===
                                                        "Merchant"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Merchant
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="contact_permission"
                                                    value="Agent"
                                                    checked={
                                                        values.contact_permission ===
                                                        "Agent"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Agent
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="contact_permission"
                                                    value="Both"
                                                    checked={
                                                        values.contact_permission ===
                                                        "Both"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Both
                                                </span>
                                            </label>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.contact_permission}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group
                                        as={Col}
                                        xs={12}
                                        className="px-3"
                                    >
                                        <div className="pri-heading1 mg-bottom-15">
                                            Reserve Required
                                        </div>
                                        <div className="d-flex tire-new">
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="reserve_required"
                                                    value="Yes"
                                                    checked={
                                                        values.reserve_required ===
                                                        "Yes"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    Yes
                                                </span>
                                            </label>
                                            <label className="radio-container">
                                                <input
                                                    type="radio"
                                                    name="reserve_required"
                                                    value="No"
                                                    checked={
                                                        values.reserve_required ===
                                                        "No"
                                                    }
                                                    onChange={handleChange}
                                                />
                                                <span className="checkmark"></span>
                                                <span className="rd-label">
                                                    No
                                                </span>
                                            </label>
                                        </div>
                                        <Form.Control.Feedback
                                            type="invalid"
                                            className="text-capitalize"
                                        >
                                            {" "}
                                            {errors.reserve_required}{" "}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Control
                                            className="notes-filed"
                                            value={this.state.notes}
                                            rows={5}
                                            as="textarea"
                                            placeholder="Deployment Notes"
                                            onChange={(e) =>
                                                this.handleNotesChange(e)
                                            }
                                        ></Form.Control>
                                        <label className="modal-lab">
                                            Deployment Notes (Optional)
                                        </label>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        )}
                    </Formik>
                    {show_spinner ? (
                        <div className="spinner">
                            <Loader />
                        </div>
                    ) : (
                        ""
                    )}
                    <p className="error-message">{errorMessage}</p>
                    <div className="modal-footer">
                        <div className="button-twoc">
                            <button
                                form="updateApproval"
                                type="submit"
                                className="btn confirm-button"
                            >
                                {" "}
                                Submit{" "}
                            </button>
                            <button
                                className="btn cancel-button"
                                onClick={() => this.props.handleCloseModel()}
                            >
                                {" "}
                                Cancel{" "}
                            </button>
                        </div>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default ProgressApproval;
